import {Component, DestroyRef, inject, Input, ViewEncapsulation} from '@angular/core';
import {NutritionFacadeService} from '@emm/management/services/nutrition-facade.service';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {LocationSetsFacadeService} from '@emm/management/services/location-sets-facade.service';
import {LocationSet} from '@emm/core/models/location-set.model';
import {Node} from '@emm/core/models/node.model';


@Component({
    encapsulation: ViewEncapsulation.None,
    selector: 'emm-nutrition-assignments-location-sets-list',
    styleUrls: ['./nutrition-assignments-location-sets-list.scss'],
    templateUrl: './nutrition-assignments-location-sets-list.component.html'
})
export class NutritionAssignmentsLocationSetsListComponent {
    @Input() nodes: Node<LocationSet>[];
    @Input() shift: number;

    private readonly destroyRef: DestroyRef = inject(DestroyRef);

    childrenNodes = {};
    loading = {};
    nodeSelected = {};
    selectedTag = this.nutritionFacade.location$;
    assignments$ = this.nutritionFacade.assignment$;
    selectedAssignment;

    constructor(
        private locationSetsFacade: LocationSetsFacadeService,
        private nutritionFacade: NutritionFacadeService
    ) {}


    // @ts-ignore
    handleClick({ tag, name, scope, disabled }): void {

        if (this.nodeSelected[tag]) {
            this.childrenNodes[tag] = [];
            this.nodeSelected[tag] = false;
            return;
        }

        this.nodeSelected[tag] = true;

        if (scope !== 'Location') {
            this.loading[tag] = true;
            this.locationSetsFacade.getLocationsByParent(tag)
                .pipe(
                    takeUntilDestroyed(this.destroyRef)
                )
                .subscribe(items => {
                    this.childrenNodes[tag] = items;
                    this.loading[tag] = false;
                });
        }

        this.nutritionFacade.selectedLocationSet({ name, tag, disabled })
            .pipe(
                takeUntilDestroyed(this.destroyRef)
            )
            .subscribe(
            (assignments) => {
                this.assignments$.next(assignments);
                if (this.assignments$.value === this.selectedAssignment) {
                    return;
                }
                this.selectedAssignment = this.assignments$.value;
                this.nutritionFacade.selectedAssignment({
                    ...this.selectedAssignment[0],
                    location: this.nutritionFacade.location.tag
                });
            });
    }



}
